module.exports = __webpack_public_path__ + "img/close-camera.0894bbad.png";